module.exports = __webpack_public_path__ + "static/gql-playground-58b1feb450d0d30863b402dc61c04186.png";